<template>
  <v-container id="regular-tables" fluid tag="section">
    <div class="text-right">
      <v-btn color="white" @click="showFilter = !showFilter" small>
        <v-icon>mdi-filter</v-icon>
      </v-btn>
      <v-menu offset-y>
        <template v-slot:activator="{ on }">
          <v-btn v-on="on" color="light-blue" small>
            <h3>
              Action
              <v-icon>mdi-menu-down</v-icon>
            </h3>
          </v-btn>
        </template>
        <v-list>
          <v-list-item :to="'/branding/create'">
            <v-list-item-title>Create</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </div>

    <v-row justify="center">
      <v-col cols="12" md="12">
        <base-material-card
          color="light-blue"
          icon="mdi-filter"
          class="px-5 py-1"
          v-if="showFilter"
        >
          <div class="filter-close">
            <v-btn color="black" class="mr-0" fab small text @click="showFilter = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>
          <v-row>
            <v-col cols="6" md="2">
              <v-text-field
                :label="$i18n.t('Branding Name')"
                class="purple-input"
                v-model="filters.name"
              />
            </v-col>

            <v-col cols="6" md="2">
              <base-client-select class="purple-input" v-model="filters.client_id"></base-client-select>
            </v-col>

            <v-col cols="12" md="2" class="text-right">
              <v-btn
                class="mr-0"
                color="grey darken"
                fab
                text
                small
                @click="clear(1)"
                style="margin-right:10px !important"
              >
                <v-icon>mdi-cached</v-icon>
              </v-btn>
              <v-btn
                color="success"
                class="mr-0"
                fab
                small
                dark
                @click="search()"
                :loading="loading"
              >
                <v-icon>mdi-magnify</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </base-material-card>
      </v-col>
    </v-row>

    <v-btn
      v-if="grid != undefined && !grid.records"
      class="text-center secondary--text pa-10"
      text
      color="primary"
      style="width:100%"
      :loading="loading"
    >{{ $i18n.t("No records available") }}</v-btn>

    <base-material-card icon="mdi-ticket" title="Brandings" class="px-5 py-3" v-if="grid.records">
      <v-simple-table>
        <thead>
          <tr>
            <th class="primary--text">Name</th>
            <th class="primary--text">Description</th>
            <th class="primary--text">Client</th>
            <th class="text-right primary--text">Action</th>
          </tr>
        </thead>

        <tbody>
          <tr v-for="branding in grid.rows" :key="branding._id">
            <td>{{ branding.name }}</td>
            <td>{{ branding.desc }}</td>
            <td>{{ branding.clientName }}</td>
            <td>
              <z-confirm-button
                class="float-right"
                color="red lighten-1"
                small
                fab
                text
                dark
                :loading="loading"
                :message="$i18n.t('Do you want to delete this branding ?')"
                @click="deleteBranding(campus)"
              >
                <v-icon>mdi-trash-can-outline</v-icon>
              </z-confirm-button>
              <v-btn
                class="float-right"
                color="primary"
                small
                fab
                text
                dark
                :to="'/branding/' + branding._id"
              >
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
            </td>
          </tr>
        </tbody>
      </v-simple-table>
      <v-container>
        <v-row justify="center">
          <v-col cols="8">
            <v-container class="max-width">
              <v-pagination
                v-model="grid.page"
                class="my-4"
                :length="grid.total"
                total-visible="10"
                @input="showPage"
              ></v-pagination>
            </v-container>
          </v-col>
        </v-row>
      </v-container>
    </base-material-card>

    <div class="py-3" />
  </v-container>
</template>

<script>
/* eslint-disable @typescript-eslint/camelcase */
import { Vue, Component, Watch } from "vue-property-decorator";
import { doGet } from "@/store/common/module/apis";
import common from "@/store/common/module/common";

@Component
export default class Brandings extends Vue {
  grid = {};
  url = "/api/branding/grid?sidx=createdAt&sord=asc&rows=30";
  showFilter = false;
  date = null;
  dateFormatted = "";
  filterDate = null;
  menu1 = false;
  filterUrl = "";
  ticketNo = "";
  priority = "";
  status = "";
  type = "";
  filters = {
    name: "",
    client_id: "",
  };

  get loading() {
    return common.loading;
  }

  @Watch("date")
  onDateChanged() {
    this.dateFormatted = this.formatDate(this.date);
    this.filterDate = this.formatDateToInt(this.date);
  }

  async mounted() {
    try {
      this.grid = await doGet(this.url);
    } catch (e) {
      common.setError(e.message);
    }
  }

  async deleteBranding(branding) {
    common.setLoading(true);
    try {
      await doGet("/api/branding/:id/delete".replace(":id", branding._id));
      common.setLoading(false);
      common.showMessage("Deleted Successfully");
      this.showPage(this.page);
    } catch (e) {
      common.setLoading(false);
      common.setError(e.message);
    }

    //   });
  }

  async showPage(page) {
    this.page = page;
    this.grid = await doGet(this.url + this.filterUrl + "&page=" + page);
    common.setLoading(false);
  }

  async clear() {
    this.filters = {};
    this.page = 1;
    this.search();
  }

  async search() {
    this.filterUrl = "";
    if (this.filters.name) this.filterUrl += "&name=" + this.filters.name;
    if (this.filters.client_id)
      this.filterUrl += "&client_id=" + this.filters.client_id;
    common.setLoading(true);
    this.showPage(1);
  }

  formatDateToInt(date) {
    if (!date) return null;
    const [year, month, day] = date.split("-");
    return parseInt(`${year}${month}${day}`);
  }

  formatDate(date) {
    if (!date) return null;
    const [year, month, day] = date.split("-");
    return `${day}-${month}-${year}`;
  }

  parseDate(date) {
    if (!date) return null;

    const [day, month, year] = date.split("-");
    return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
  }
}
</script>

<style scoped>
.filter-close {
  position: absolute;
  right: 5px;
  top: 5px;
}
</style>
